const feed = ({ feedId = '', feedType = '', feedTitle = '' } = {}) => ({
  Feed: { feedId, feedType, feedTitle },
});

export default feed;
